import I18n from 'app/i18n';
import moment from 'moment';

const formatTimeMinSec = (val: number): string => {
    const duration = moment.duration(val, 'seconds');
    return `${duration.minutes()}${I18n.t('minutes_short')} ${duration.seconds()}s`;
};

export default formatTimeMinSec;
